// ============================================
// File: src/components/teams/hooks/usePendingMembers.js
// Live subscribe to teams/{id}/pendingMembers
// ============================================
import { useEffect, useState } from 'react';
import { collection } from 'firebase/firestore';
import { safeOnSnapshot } from '../../../utils/firestoreSubscriptions';
import { db } from '../../../firebase-client';
import { normalizePendingMemberStatus } from '../../../utils/waitlist';

export function usePendingMembers(id, enabled = true) {
  const [pending, setPending] = useState([]);
  useEffect(() => {
    if (!id || !enabled) {
      setPending([]);
      return;
    }
    const unsub = safeOnSnapshot(collection(db, 'teams', id, 'pendingMembers'), qs => {
      const items = qs.docs.map(d => ({
        id: d.id,
        ...d.data()
      })).filter(m => ['waiting', 'awaiting_club_payment', 'awaiting_payment_round'].includes(normalizePendingMemberStatus(m.status)));
      setPending(items);
    }, err => {
      if (err?.code === 'permission-denied') return;
    });
    return () => unsub();
  }, [id, enabled]);
  return pending;
}
